export default __webpack_public_path__ + "static/media/P20013.87213f03.png";